﻿import { Dispatch } from 'redux';
import { removeSpacesFromObject } from '../../helpers/utilityFunctions/utilityFunctions';
import { PatientDetail } from '../../model/patient/patientDetail';
import { TestData } from '../../model/testData';
import { TestDataCategoryType } from '../../model/testDataCategoryType';
import { activeTestService } from '../../services/activeTestService';
import { healthcareProfessionalService } from '../../services/healthcareProfessionalService';
import {
  CANCEL_PENDING_AUTHORISATION,
  CLEAR_SELECTED_PATIENT_TEST_DETAIL,
  FETCH_PATIENTS,
  FETCH_PATIENTS_FAILURE,
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENT_DETAIL,
  FETCH_PATIENT_DETAIL_FAILURE,
  FETCH_PATIENT_DETAIL_SUCCESS,
  FETCH_PATIENT_TESTS,
  FETCH_PATIENT_TESTS_FAILURE,
  FETCH_PATIENT_TESTS_SUCCESS,
  FETCH_PATIENT_TEST_DETAIL,
  FETCH_PATIENT_TEST_DETAIL_FAILURE,
  FETCH_PATIENT_TEST_DETAIL_SUCCESS,
  FETCH_PATIENT_TEST_TABLE_DATA,
  FETCH_PATIENT_TEST_TABLE_DATA_FAILURE,
  FETCH_PATIENT_TEST_TABLE_DATA_SUCCESS,
  FETCH_PENDING_PATIENTS,
  FETCH_PENDING_PATIENTS_FAILURE,
  FETCH_PENDING_PATIENTS_SUCCESS,
  SET_SELECTED_TEST_DATE,
} from '../constants';
import { PatientActionTypes } from '../types/patientActionTypes';

//patients

export function fetchPatients(): PatientActionTypes {
  return {
    type: FETCH_PATIENTS,
  };
}

export function fetchPatientsSuccess(data: any) {
  return {
    type: FETCH_PATIENTS_SUCCESS,
    payload: removeSpacesFromObject(data),
  };
}

export function fetchPatientsError(error: string): PatientActionTypes {
  return {
    type: FETCH_PATIENTS_FAILURE,
    payload: error,
  };
}

export function getPatients(accoundID: string, isAuthorized: boolean) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(fetchPatients());
    return healthcareProfessionalService
      .getPatients(accoundID, isAuthorized)
      .then(
        (response: any) => dispatch(fetchPatientsSuccess(response))
        //error => dispatch(someerror('woody', buzz, error))
      );
  };
}

export function fetchPendingPatients(): PatientActionTypes {
  return {
    type: FETCH_PENDING_PATIENTS,
  };
}

export function fetchPendingPatientsSuccess(data: any) {
  return {
    type: FETCH_PENDING_PATIENTS_SUCCESS,
    payload: data,
  };
}

export function fetchPendingPatientsError(error: string): PatientActionTypes {
  return {
    type: FETCH_PENDING_PATIENTS_FAILURE,
    payload: error,
  };
}

export function getPendingPatients(accoundID: string) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(fetchPendingPatients());
    return healthcareProfessionalService.getPendingPatients(accoundID).then(
      (response: any) => dispatch(fetchPendingPatientsSuccess(response))
      //error => dispatch(someerror('woody', buzz, error))
    );
  };
}

export function fetchPatientDetail(): PatientActionTypes {
  return {
    type: FETCH_PATIENT_DETAIL,
  };
}

export function fetchPatientDetailSuccess(data: PatientDetail) {
  return {
    type: FETCH_PATIENT_DETAIL_SUCCESS,
    payload: data,
  };
}

export function fetchPatientDetailError(error: string): PatientActionTypes {
  return {
    type: FETCH_PATIENT_DETAIL_FAILURE,
    payload: error,
  };
}

export function getPatientDetail(patientAcountGuid: string) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(fetchPatientDetail());
    return healthcareProfessionalService
      .getPatientDetail(patientAcountGuid)
      .then(
        (response: any) => dispatch(fetchPatientDetailSuccess(response)),
        (error: any) =>
          dispatch(
            fetchPatientDetailError(
              error?.message || 'Failed to load patient details'
            )
          )
      );
  };
}

export function cancelPendingAuthorisation(): PatientActionTypes {
  return {
    type: CANCEL_PENDING_AUTHORISATION,
  };
}

export function cancelPendingPatientAuthorisation(
  accoundID: string,
  patientID: string
) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(cancelPendingAuthorisation());
    return healthcareProfessionalService
      .revokePatient(accoundID, patientID)
      .then((response: any) => {
        return response;
      });
    //error => dispatch(someerror('woody', buzz, error))
  };
}

//patientTests

export function fetchPatientTests(): PatientActionTypes {
  return {
    type: FETCH_PATIENT_TESTS,
  };
}

export function fetchPatientTestsSuccess(data: any) {
  return {
    type: FETCH_PATIENT_TESTS_SUCCESS,
    payload: data,
  };
}

export function fetchPatientTestsError(error: string): PatientActionTypes {
  return {
    type: FETCH_PATIENT_TESTS_FAILURE,
    payload: error,
  };
}

export function getPatientTests(patientId: string, testType: string) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(fetchPatientTests());
    return activeTestService.GetPatientTests(patientId, testType).then(
      (response: any) => dispatch(fetchPatientTestsSuccess(response))
      //error => dispatch(someerror('woody', buzz, error))
    );
  };
}

//patientTestDetail
export function fetchPatientTestDetail(): PatientActionTypes {
  return {
    type: FETCH_PATIENT_TEST_DETAIL,
  };
}

export function fetchPatientTestDetailSuccess(data: TestData) {
  return {
    type: FETCH_PATIENT_TEST_DETAIL_SUCCESS,
    payload: data,
  };
}

export function fetchPatientTestDetailError(error: string): PatientActionTypes {
  return {
    type: FETCH_PATIENT_TEST_DETAIL_FAILURE,
    payload: error,
  };
}

export function getPatientTestDetail(testGuid: string, testType: string) {
  return function action(dispatch: Dispatch<any>) {
    dispatch(fetchPatientTestDetail());
    return activeTestService.GetPatientTestDetail(testGuid, testType).then(
      (response: any) => {
        dispatch(fetchPatientTestDetailSuccess(response));
      }
      //error => dispatch(someerror('woody', buzz, error))
    );
  };
}

//patientTestTableData
export function fetchPatientTestTableDataByCategory(): PatientActionTypes {
  return {
    type: FETCH_PATIENT_TEST_TABLE_DATA,
  };
}

export function fetchPatientTestTableDataByCategorySuccess(
  key: TestDataCategoryType,
  data: TestData
) {
  return {
    type: FETCH_PATIENT_TEST_TABLE_DATA_SUCCESS,
    payload: {
      key: key,
      data: data,
    },
  };
}

export function fetchPatientTestTableDataByCategoryError(
  error: string
): PatientActionTypes {
  return {
    type: FETCH_PATIENT_TEST_TABLE_DATA_FAILURE,
    payload: error,
  };
}

export function setSelectedTestDate(dateTime: string): PatientActionTypes {
  return {
    type: SET_SELECTED_TEST_DATE,
    payload: dateTime,
  };
}

export function getPatientTestTableDataByCategory(
  testId: string,
  dateTime: string,
  activeType: string
) {
  return async function action(dispatch: Dispatch<any>) {
    const categoryKeys = Object.keys(TestDataCategoryType).filter((key: any) =>
      isNaN(Number(key))
    ) as Array<keyof typeof TestDataCategoryType>;

    const getCategoryPayload = (response: any, categoryKey: string) => {
      if (!response || typeof response !== 'object') return undefined;

      // Supports common response shapes:
      // 1) { General: {...}, Temporal: {...} }
      // 2) { general: {...}, temporal: {...} }
      // 3) [{ testDataCategoryType: 'General', data: {...} }, ...]
      if (categoryKey in response) return response[categoryKey];
      const lower = categoryKey.toLowerCase();
      if (lower in response) return response[lower];

      if (Array.isArray(response)) {
        const match = response.find((entry: any) => {
          const rawType = entry?.testDataCategoryType ?? entry?.category ?? entry?.key;
          return rawType === categoryKey || rawType === lower;
        });
        return match?.data ?? match?.value ?? match;
      }

      return undefined;
    };

    const fetchWithRetry = async (attempts = 3, retryDelayMs = 250) => {
      for (let attempt = 1; attempt <= attempts; attempt++) {
        try {
          return await activeTestService.GetPatientTestTableDataByCategories(
            testId,
            activeType
          );
        } catch (error) {
          if (attempt === attempts) throw error;
          await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
        }
      }
      throw new Error('Failed to fetch test table categories');
    };

    dispatch(setSelectedTestDate(dateTime));
    dispatch(fetchPatientTestTableDataByCategory());

    try {
      const response = await fetchWithRetry();
      let dispatchedCount = 0;

      categoryKeys.forEach((key) => {
        const categoryData = getCategoryPayload(response, key);
        if (categoryData !== undefined) {
          dispatch(
            fetchPatientTestTableDataByCategorySuccess(
              key as unknown as TestDataCategoryType,
              categoryData
            )
          );
          dispatchedCount += 1;
        }
      });

      if (dispatchedCount === 0) {
        dispatch(
          fetchPatientTestTableDataByCategoryError(
            'No category data found for this test.'
          )
        );
      }
    } catch (error: any) {
      dispatch(
        fetchPatientTestTableDataByCategoryError(
          error?.message || 'Failed to load test table data'
        )
      );
    }
  };
}

export function clearSelectedTestData(): PatientActionTypes {
  return {
    type: CLEAR_SELECTED_PATIENT_TEST_DETAIL,
  };
}
